<script setup lang='ts'>
const props = withDefaults(defineProps<{
  dark?: boolean,
  light?: boolean
}>(), {
  dark: false,
  light: false
});

const classes = computed(() => {
  return {
    'bg-light': props.light,
    'bg-dark': props.dark,
  }
})
</script>

<template>
  <div :class="classes" class="section-container section-element">
    <slot name="header"/>
    <slot/>
  </div>
</template>

<style scoped lang="scss">

.section-container {
  padding: 1rem 1rem;
  font-size: 1.1rem;
  width: 100%;
}

@media (min-width: 768px) {
  .section-container {
    padding: 2rem 5rem;
  }
}

@media (min-width: 992px) {
  .section-container {
    padding: 2rem 5rem;
  }
}

@media (min-width: 1200px) {
  .section-container {
    padding: 2rem 10rem;
  }
}

</style>
